import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  text?: string;
  className?: string;
  href?: string;
}
export function CTAButton({
  text = 'QUIERO RECUPERAR MI ENERGÍA AHORA',
  className = '',
  href = '#offer'
}: CTAButtonProps) {
  const isExternal = href.startsWith('http');
  const handleClick = () => {
    if (isExternal) {
      trackAddToCart();
    }
  };
  return <motion.a href={href} onClick={handleClick} {...isExternal ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative inline-flex items-center justify-center
        bg-gradient-to-r from-amber-500 to-amber-400 
        text-slate-950 font-bold text-lg md:text-xl
        py-4 px-8 rounded-full 
        shadow-[0_0_20px_rgba(245,158,11,0.3)] 
        hover:shadow-[0_0_35px_rgba(245,158,11,0.5)] 
        transition-shadow duration-300
        overflow-hidden group
        ${className}
      `} data-id="element-13">
      <span className="relative z-10 flex items-center gap-2" data-id="element-14">{text}</span>
      <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:animate-pulse z-0" data-id="element-15" />
    </motion.a>;
}